var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { Step } from "./components";
var StepIndicators = function (_a) {
    var currentStep = _a.currentStep, sx = _a.sx, steps = _a.steps;
    return (_jsx(Stack, __assign({ width: "100%", pb: 12, mt: 12, px: 16, sx: sx }, { children: _jsx(Stack, __assign({ width: "100%", position: "relative", direction: "row" }, { children: steps.map(function (step, idx) { return (_jsx(Step, { idx: idx, step: step, currentStep: currentStep, previousStep: steps === null || steps === void 0 ? void 0 : steps[idx - 1], lastStep: steps.length - 1 }, idx)); }) })) })));
};
export default StepIndicators;
